// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608131400/js/" + chunkId + "." + {"44":"0c19a653","225":"adb6aeb8","481":"b491dd11","486":"cbf60f1c","770":"769280d0"}[chunkId] + ".0.2532600946887317.chunk.js";
};